<template>
  <div class="use-new">
    <b-row>
      <b-col class="text-left" cols="12">
        <b-input-group class="input-group-merge">
          <b-input-group-prepend is-text>
            <feather-icon icon="SearchIcon"/>
          </b-input-group-prepend>
          <b-form-input id="searchbar" v-model="searchQuery" placeholder="Tìm kiếm theo từ khóa...."
                        v-on:keydown.enter="quickSearch"/>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12 mt-50">
        <b-list-group class="list-group-circle mt-2 ">
          <b-list-group-item v-for="item in listNews" :key="item.id" :title="item.contents"
                             class="list-group-item text-body" v-bind:class="{ 'active': isSelected(item.id) }"
                             v-on:click="detailClick(item)">
            <span :style="[ item.isRead ? {opacity: 0.5}: {opacity: 1}]"> {{ item.name }} </span>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>

    <b-modal id="modal-view" :title="getTitle()" scrollable size="xl" @ok="handleOk">
      <b-row class="mt-50">
        <b-col cols="12">
          <b-form-group>
            <label>Nội dung câu hỏi: </label>
            <label class="ml-50"> {{ currentItem.question }}</label>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group>
            <!-- eslint-disable vue/no-v-html -->
            <div class="question-content" v-html="currentItem.answer"/>
            <!-- eslint-enable -->
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group>
            <b-input-group v-if="currentItem && currentItem.answer_file" class="input-group-merge"
                           @click="downloadFile(currentItem.answer_file)">
              <div class="sample-file__download">
                <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
              </div>
              {{ currentItem.answer_file }}
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-left">
        <b-button class="btn-sm mr-50 ml-50" variant="primary" @click="showFeedback(currentItem)">
          <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
          Gửi đề xuất góp ý
        </b-button>
        <b-button class="btn-sm mr-50 ml-50" variant="primary" @click="showSMS(currentItem)">
          <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
          Gửi SMS
        </b-button>
      </b-row>
    </b-modal>
    <!-- Hướng dẫn sử dụng -->
    <!-- Gửi nội dung feedback -->
    <b-modal id="modal-feedback" scrollable size="xl" title="Gửi ý kiến phản hồi" @ok="handleFeedbackOk">
      <b-row class="mt-50">
        <b-col cols="12">
          <b-form-group>
            <label>Thuộc: </label>
            <label class="ml-50"> {{ feedbackItem.newName }}</label>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-textarea id="textarea-auto-height" v-model="feedbackItem.contents" max-rows="8"
                           placeholder="Nhập đề xuất của bạn" rows="8"/>
        </b-col>
        <b-col class="mt-50 text-left" cols="12">
          <b-form-group>
            <div v-if="feedbackItem && feedbackItem.file_path">
              {{ feedbackItem.file_path }}
            </div>
            <b-form-file v-model="feedbackItem.file" accept="application/pdf,application/vnd.ms-excel,application/csv,application/vnd.openxmlformats-officedocument.wordprocessingml.document" plain
                         v-on:input="uploadFile">
            </b-form-file>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <!-- Gửi sms -->
    <b-modal id="modal-sms" scrollable size="xl" title="Gửi sms" @ok="handleSMSOk">
      <b-row class="mt-50">
        <b-col cols="12">
          <b-form-group>
            <label>Số điện thoại nhận </label>
            <input v-model="smsItem.phone" class="phone-re"
                   maxlength="10"
                   onKeyDown="if(this.value.length==10 && event.keyCode>47 && event.keyCode < 58) return false;" type="number"/>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-textarea id="textarea-auto-height" v-model="smsItem.contents" max-rows="8" placeholder="Nhập nội dung SMS"
                           rows="8"/>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BForm,
  BInputGroup,
  BFormInput,
  BCardText,
  BInputGroupPrepend,
  BListGroup,
  BListGroupItem,
  BFormGroup,
  VBTooltip,
  BFormFile,
  BButton,
  BFormTextarea
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import moment from "moment";
import {getuserName} from '@/@core/utils/utils';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    BForm,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BListGroupItem,
    BListGroup,
    BFormGroup,
    VBTooltip,
    BFormFile,
    BButton,
    BFormTextarea
  },

  data() {
    return {
      searchQuery: "",
      listNews: [],
      currentItem: {},
      selected: 0,
      modal_title: "",
      feedbackItem: {},
      smsItem: {},
      emalConfigs: []
    };
  },
  computed: {},
  created() {

    const topicId = this.$route.params.topicId;
    if (topicId && topicId > 0) {
      this.fetchData(this.$route.params.topicId);
    }
    this.loadEmailConfig();
  },
  watch: {
    $route(to, from) {
      let topicId = to.params.topicId ? to.params.topicId : 0;
      if (topicId > 0) {
        this.fetchData(topicId);
      }
    },
  },
  methods: {
    getTitle() {
      return this.modal_title;
    },
    quickSearch() {
      const topicId = this.$route.params.topicId;
      if (topicId && topicId > 0) {
        this.fetchData(this.$route.params.topicId);
      }
    },
    handleOk() {
    },
    fetchData(topicId) {
      useJwt
          .get("portal/QAbytopicid?topicId=" + topicId + "&filter=" + this.searchQuery)
          .then((response) => {
            if (response.data.code == 200) {
              this.listNews = response.data.result;
            }
          })
          .catch((err) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.result,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          });
    },
    detailClick(row) {
      const id = row.id;
      useJwt
          .get("portal/getQAbyById?id=" + id)
          .then((response) => {
            if (response.data.code == 200) {
              row.isRead = true;
              this.currentItem = response.data.result[0];
              this.currentItem.effect_date = this.formatDate(this.currentItem.effect_date);
              if (this.currentItem.from_date) {
                this.currentItem.from_date = this.formatDate(this.currentItem.from_date);
              }
              if (this.currentItem.to_date) {
                this.currentItem.to_date = this.formatDate(this.currentItem.to_date);
              }
              this.modal_title = this.currentItem.answer;
              this.$bvModal.show("modal-view");
            }
          })
          .catch((err) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.result,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          });
    },
    isSelected: function (i) {
      return i === this.selected
    },
    dateFormat(v) {
      return moment(v, 'YYYYMMDDHHmmss').format('DD/MM/YYYY hh:mm:ss')
    },
    formatDate(v) {
      return moment(v, 'YYYY/MM/DD').format('DD/MM/YYYY')
    },
    async loadEmailConfig() {
      useJwt.get("portal/emailconfig").then((response) => {
        var result = response.data;
        if (result.code == 200) {

          result.result.forEach(item => {
            this.emalConfigs.push(item.email);
          });
        }

        this.isLoading = false;
        this.loading(false);
      });
    },

    showFeedback(itemNew) {
      this.feedbackItem = {};
      this.feedbackItem.new_group_id = itemNew.id;
      this.feedbackItem.newName = itemNew.answer;
      this.$bvModal.show("modal-feedback");
    },
    async handleFeedbackOk(bvModalEv) {
      bvModalEv.preventDefault();
      const userName = getuserName();
      if (!this.feedbackItem.contents || this.feedbackItem.contents.trim().length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải nhập nội dung góp ý!",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return false;
      }

      try {
        const createParams = {
          id: 0,
          new_group_id: this.feedbackItem.new_group_id,
          contents: this.feedbackItem.contents,
          notes: this.feedbackItem.notes,
          created_at: userName,
          type: 1,
          emails: this.emalConfigs.join(','),
          newName: this.feedbackItem.newName,
          file_path: this.feedbackItem.file_path
        };
        const res = await useJwt.post("portal/feedback", createParams);
        if (res.data.code == 200) {
          this.$bvModal.hide("modal-feedback");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thêm mới ý kiến phản hồi!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi thêm mới ý kiến phản hồi ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    showSMS(itemNew) {
      this.smsItem = {};
      this.smsItem.ref_id = itemNew.id;
      this.smsItem.newName = itemNew.answer;
      this.$bvModal.show("modal-sms");
    },

    async handleSMSOk(bvModalEv) {
      bvModalEv.preventDefault();
      const userName = getuserName();
      if (!this.smsItem.phone || this.smsItem.phone.trim().length < 10) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải số điện thoại nhận SMS!",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return false;
      }
      if (!this.smsItem.contents || this.smsItem.contents.trim().length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải nhập nội dung SMS!",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return false;
      }
      try {
        const createParams = {
          id: 0,
          ref_id: this.smsItem.ref_id,
          contents: this.smsItem.contents.trim(),
          phone: this.smsItem.phone,
          created_at: userName
        };
        const res = await useJwt.post("portal/sms", createParams);
        if (res.data.code == 200) {
          this.$bvModal.hide("modal-sms");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Gửi sms thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi gửi sms.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    async uploadFile() {
      var formData = new FormData();
      formData.append("file", this.feedbackItem.file);
      const res = await useJwt.post(`portal/upload`, formData);
      if (res.data.code == 200) {
        this.feedbackItem.file_path = res.data.result;
      }
    },
    async downloadFile(filePath) {
      try {
        const downloadParams = {filePath: filePath};
        const arrFile = filePath.replaceAll('\\', '/').split('/');
        const res = await useJwt.postDownload("portal/download", arrFile[1], downloadParams);
        // if (res.status != 200) {
        //   this.$toast({
        //     component: ToastificationContent,
        //     props: {
        //       title: "File không đúng hoặc không còn tồn tại.",
        //       icon: "AlertTriangleIcon",
        //       variant: "danger"
        //     },
        //   });
        // }
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "File không đúng hoặc không còn tồn tại.",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
      }
    }
  },
};

</script>
<style lang="css">
.list-group-item:focus,
list-group-item:hover,
button.list-group-item:focus,
button.list-group-item:hover {
  color: #555;
  text-decoration: none;
  background-color: rgb(34 41 47 / 10%) !important;
  cursor: pointer;
}

.list-group-item.active,
.list-group-item.active:focus,
.list-group-item.active:hover {
  z-index: 2;
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
  cursor: pointer;
}

.list-group-item > span {
  cursor: pointer;
}

.modal .modal-header {
  background-color: #ed1f24;
  color: black !important;
}

.modal-header h5 {
  color: black !important;
}

.use-new label {
  line-height: 50px;
  font-size: 1rem;
  min-width: 100px;
}

.border-left {
  border-left: 2px solid #ccc;
}

.question-content {
  min-height: 200px;
}

.phone-re {
  display: inline-block;
  width: 200px;
  margin-left: 20px;
  border: 1px solid #ddd;
  height: 30px;
  border-radius: 3px;
}

input:focus-visible {
  outline: none !important;
  border: 1px solid #ed1f24;
}

.question-content {
  min-height: 330px;
}

.input-group-merge {
  cursor: pointer;
}
</style>
<style lang="scss">
@import "@core/scss/vue/pages/page-knowledge-base.scss";
@import "@core/scss/vue/bootstrap-vue/tooltip";
</style>
